var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrinter = function SvgPrinter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 19v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8zm7 7h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2m0-3h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 10H6a2.996 2.996 0 0 0-3 3v8a3.01 3.01 0 0 0 3 3h3v-6a1.003 1.003 0 0 1 1-1h12a1.003 1.003 0 0 1 1 1v6h3a3.01 3.01 0 0 0 3-3v-8a2.996 2.996 0 0 0-3-3m-2 5a.99.99 0 0 1-1-1 1 1 0 1 1 1 1M23 5v4H9V5a1.003 1.003 0 0 1 1-1h12a1.003 1.003 0 0 1 1 1"
  })));
};
export default SvgPrinter;